import React from "react";
import { Link } from "react-router-dom";
import { MapPinOff, Home, LayoutDashboard } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function NotFound() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 rounded-2xl bg-orange-100 flex items-center justify-center mx-auto mb-6">
          <MapPinOff className="w-10 h-10 text-orange-600" />
        </div>
        <div className="font-display font-bold text-6xl text-slate-900 mb-2">404</div>
        <h1 className="font-display font-bold text-2xl text-slate-900 mb-3">Page introuvable</h1>
        <p className="text-slate-500 mb-8 leading-relaxed">
          La page que vous cherchez n'existe pas ou a été déplacée.
          Vérifiez l'adresse, ou repartez d'un endroit connu.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-slate-900 hover:bg-slate-800 text-white rounded-xl font-display font-bold text-sm transition-colors"
          >
            <Home className="w-4 h-4" />
            Accueil
          </Link>
          {user && (
            <Link
              to="/dashboard"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-orange-600 hover:bg-orange-700 text-white rounded-xl font-display font-bold text-sm transition-colors"
            >
              <LayoutDashboard className="w-4 h-4" />
              Tableau de bord
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
